import React from "react";
import styles from "./ai-rag-chat-modal.module.scss";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import sparklesIcon from "@src/assets/svg/sparkles-solid-white.svg";
import caretRight from "@src/assets/svg/caret-right.svg";
import caretDown from "@src/assets/svg/caret-down.svg";
import DOMPurify from "dompurify";

const cssClassName = "ai-rag-chat-modal";

interface ThinkingSectionProps {
  thinking: string;
  isExpanded: boolean;
  onToggle: () => void;
}

export const ThinkingSection: React.FC<ThinkingSectionProps> = ({
  thinking,
  isExpanded,
  onToggle,
}) => {
  return (
    <div className={styles[`${cssClassName}__thinking-wrapper`]}>
      <div
        className={styles[`${cssClassName}__thinking-header`]}
        role="button"
        tabIndex={0}
        onClick={onToggle}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onToggle();
          }
        }}
      >
        <FlexRowContainer horizontalGap={4}>
          <img
            className={styles[`${cssClassName}__sparkles-icon`]}
            src={sparklesIcon}
            alt="Sparkles"
          />
          <span className={styles[`${cssClassName}__thinking-header-text`]}>
            Thought process
          </span>
          <span className={styles[`${cssClassName}__caret`]}>
            {isExpanded ? (
              <img
                className={styles[`${cssClassName}__caret`]}
                src={caretDown}
                alt="Caret Down"
              />
            ) : (
              <img
                className={styles[`${cssClassName}__caret`]}
                src={caretRight}
                alt="Caret Right"
              />
            )}
          </span>
        </FlexRowContainer>
      </div>
      {isExpanded && (
        <div
          className={styles[`${cssClassName}__thinking-content`]}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(thinking),
          }}
        />
      )}
    </div>
  );
};
